import translationEN from "./en/translation.json";
import translationRU from "./ru/translation.json";

import widgetsEN from "./en/widgets.json";
import widgetsRU from "./ru/widgets.json";

import logsEN from "./en/logs.json";
import logsRU from "./ru/logs.json";

export const resources = {
  en: {
    translation: translationEN,
    widgets: widgetsEN,
    logs: logsEN,
  },
  ru: {
    translation: translationRU,
    widgets: widgetsRU,
    logs: logsRU,
  },
};
